import { ConcreteException } from '../exception';
export class WalletException extends ConcreteException {
    errorClass = 'WalletException';
}
//# sourceMappingURL=WalletException.js.map